module.exports = __webpack_public_path__ + "img/Cookie_1_resize_49.26076282.png";